import { Component, Inject } from '@angular/core';
import { Form, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MallaService } from 'src/app/services/malla.service';
import { ICuenta } from '../interfaces/ICuenta';
import { IAlert } from '../interfaces/IAlertInfo';

export interface DialogData {
  title: string;
  content: string;
}

export interface ITransaccion {
  _id: string;
  cuentaOrigen: any;
  cuentaDestino: any;
  tipo: string;
  fecha: Date;
  monto_ejecutado: number;
  monto_pendiente: number;
  monto_recibido: number;
  monto_retenido: number;
  monto_salvado: number;
  __v;
  createdAt;
  updatedAt;
}

@Component({
  selector: 'app-malla-modal-detalle',
  templateUrl: './malla-modal-detalle.component.html',
  styleUrls: ['./malla-modal-detalle.component.scss'],
})
export class MallaModalDetalleComponent {
  public form: FormGroup;
  node: any;
  cuentaModel: ICuenta;
  saldoRetenido: number = 0;
  transacciones: ITransaccion;
  cuenta: string;
  trecibidas = [];
  tenviadas = [];
  skuld: boolean;
  cuenta_afectada: boolean = false;
  status: string;
  transaccionesModificadas: ITransaccion[] = [];
  alertInfo: IAlert;

  constructor(
    public dialogRef: MatDialogRef<MallaModalDetalleComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public mallaService: MallaService,
    public _snackbar: MatSnackBar
  ) {
    this.node = data.clickedNodes[0];
    this.cuenta = this.node.numero_cuenta;
    this.status = this.data.status;
    this.skuld = data.skuld;
    this.alertInfo = data.alertInfo;

    this.getCuenta();
    if (this.node.retenido) this.saldoRetenido = this.node.retenido.monto;
    if (this.node.numero_cuenta)
      this.findTransacciones(this.node, this.data.transacciones);
  }

  get canEdit() {
    return this.status == 'running' && this.skuld;
  }

  async getCuenta() {
    this.cuentaModel = (await this.mallaService
      .getCuenta(this.node._id)
      .toPromise()) as ICuenta;
  }

  async findTransacciones(cuentaNode, transacciones) {
    const numero_cuenta = cuentaNode.numero_cuenta;
    let transaccionesOrigen = [];
    let transaccionesDestino = [];
    for (let transaccion of transacciones) {
      const referencia = transaccion.referencia;
      transaccion = transaccion.transaccion;
      let numero_cuenta_transaccion_o = transaccion.cuentaOrigen.numero_cuenta;
      let numero_cuenta_transaccion_d = transaccion.cuentaDestino.numero_cuenta;
      transaccion.referencia = referencia;
      transaccion.ip = transaccion.ip;
      transaccion.ip_no_financiera = transaccion.ip_no_financiera;
      transaccion.observacion = transaccion.observacion;
      let fecha = new Date(transaccion.fecha);
      transaccion.fecha = fecha;
      if (numero_cuenta == numero_cuenta_transaccion_o) {
        transaccion.cuenta = numero_cuenta_transaccion_d;
        transaccionesOrigen.push(transaccion);
      }
      if (numero_cuenta == numero_cuenta_transaccion_d) {
        transaccion.cuenta = numero_cuenta_transaccion_o;
        transaccionesDestino.push(transaccion);
      }
    }
    this.tenviadas = transaccionesOrigen;
    this.trecibidas = transaccionesDestino;
  }

  get isCuenta() {
    return this.node.numero_cuenta != undefined;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  dismiss(): void {
    this.dialogRef.close(this.transaccionesModificadas);
  }

  createNewNode() {
    // Log data in createNewNode
  }

  updateSaldoRetenido() {
    // Convertir el valor a string
    let value = this.saldoRetenido.toString();
    // Eliminar los puntos de los miles
    value = value.replace(/\./g, '');
    // Reemplazar la coma decimal por un punto
    value = value.replace(/,/g, '.');
    // Convertir a número flotante
    this.saldoRetenido = parseFloat(value);

    this.mallaService
      .retenido(this.data.caso, this.node._id, this.saldoRetenido)
      .subscribe((response) => {
        this._snackbar.open('Saldo retenido guardado con éxito', 'Cerrar', {
          duration: 1000,
        });
      });
  }

  async guardarTransferencia(transaccion) {
    try {
      const resp = await this.mallaService
        .updateTransferencia(transaccion)
        .toPromise();
      this._snackbar.open(`Transacción actualizada`, `Cerrar`, {
        duration: 1000,
      });

      // Verificar si la transacción ya existe en transaccionesModificadas
      const index = this.transaccionesModificadas.findIndex(
        (t) => t._id === transaccion._id
      );

      // Si existe, eliminarla
      if (index !== -1) {
        this.transaccionesModificadas.splice(index, 1);
      }

      // Agregar la transacción actualizada a transaccionesModificadas
      this.transaccionesModificadas.push(transaccion);

    } catch (err) {
      console.log(err);
      this._snackbar.open(`Error al guardar la transaccion`, ``, {
        duration: 500,
      });
    }
  }
}
